import { lazy as originalLazy } from 'react';
import customLazy from './lazyLoading';

const lazy = (CONFIG.dataDog.enabled && CONFIG.dataDog.clientToken) ? customLazy : originalLazy;

export default lazy;
